import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import * as _ from 'lodash-es';
import { JsonObjectFactoryService } from '../../../../shared/_services/json-object-factory.service';

@Injectable({
  providedIn: 'root'
})
export class Form851TaxualinfoService {

  constructor(
    private http: HttpClient,
    private jsonObjectFactory: JsonObjectFactoryService
  ) { }

  private buildFormData(params: Record<string, any>): string {
    const urlEncoded = new URLSearchParams();
    Object.keys(params).forEach(key => {
      const value = params[key];
      if (value !== undefined && value !== null) {
        urlEncoded.set(key, typeof value === 'object' ? JSON.stringify(value) : String(value));
      }
    });
    return urlEncoded.toString();
  }

  private getPostOptions(): { headers: HttpHeaders; withCredentials: boolean } {
    return {
      headers: new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' }),
      withCredentials: true
    };
  }

  /**
   * Load Form 851 Part III data - action_code 32s561 (same as AngularJS fetch_tbl_list_data).
   * Routed through JsonObjectFactoryService.getJSONObj6 for parity with legacy
   * JsonObjectFactory.getJSONObj (merges globalService.globalParams: client_key,
   * sso_id, jcd_key, jurisdiction, etc. - which the manual URL build was dropping).
   */
  loadForm851(
    baseUrl: string,
    globalService: any,
    filterParams: any
  ): Observable<any> {
    const url = `${baseUrl}/loadJsonObject`;
    const params: any = {
      action_code: '32s561',
      tax_year: filterParams?.tax_year ?? globalService?.globalParams?.tax_year ?? '',
      scenario: filterParams?.scenario ?? globalService?.globalParams?.scenario ?? '',
      jcd_key: filterParams?.jcd_key ?? globalService?.globalParams?.jcd_key ?? '',
      filing_group: filterParams?.filing_group ?? filterParams?.filing_key ?? ''
    };
    return this.jsonObjectFactory.getJSONObj6(url, params, globalService, filterParams);
  }

  /**
   * Save Form 851 Part III - action_code oqco9i, process_name INSERT_FORM_851_DATA.
   * Payload matches AngularJS saveform851modal (Form851Service.js).
   */
  saveForm851(
    baseUrl: string,
    jsonSettings: any[],
    jsonObj: any[],
    globalService: any,
    filterParams: any,
    ssoId: string = ''
  ): Observable<any> {
    const url = `${baseUrl}/saveJsonObject?action_code=oqco9i`;
    const checkLockedbj = [{
      consol_group_key: filterParams?.filing_key ?? filterParams?.filing_group ?? ''
    }];
    // Legacy merges GlobalService.globalParams (flat) with filterParams - mirror that
    // rather than the full header object, otherwise nested {globalParams: {...}}
    // would end up as "[object Object]" in the form-encoded body.
    const globalParams = globalService?.globalParams ?? {};
    let params: any = _.merge({}, globalParams, filterParams || {});
    params.checkLockedbj = JSON.stringify(checkLockedbj);
    params = _.extend({ jsonObj: JSON.stringify(jsonObj) }, params);
    params = _.extend({ jsonSettings: JSON.stringify(jsonSettings) }, params);
    params.process_name = 'INSERT_FORM_851_DATA';
    params.sso_id = ssoId || globalParams.sso_id || '';
    return this.http.post<any>(url, this.buildFormData(params), this.getPostOptions());
  }
}
